import React from "react";
import PropTypes from "prop-types";
import { BQLink } from "../../../../atoms/bqlink";
import { getStorySlug } from "../../../../../helpers/utils";
import "./research-report-card-alt.m.css";
import { FourStarIcon } from "../../../../atoms/material-icons";
import { isStoryExclusive } from "../../../../../helpers/story-helpers";

const ResearchReportCardAlt = ({ report }) => (
  <div styleName="wrapper" className="card-with-reaction-title">
    <div styleName="author-name">
      {report?.["author_byline"]}
      <FourStarIcon color="#CE9445" size="14px" />
    </div>
    <BQLink href={new URL(report?.link).pathname}>
      <div styleName="headline">{report?.title}</div>
    </BQLink>
  </div>
);

ResearchReportCardAlt.propTypes = {
  report: PropTypes.object.isRequired,
};

export default ResearchReportCardAlt;
